export const MATERIAL_COLUMNS = Object.freeze({
  serialNo: 'serialNo',
  materialName: 'materialName',
  materialCode: 'materialCode',
  materialType: 'materialType',
  certificateType: 'certificateType',
  declarationUnit: 'declarationUnit',
  workingUnit: 'workingUnit',
  conversionFactor: 'conversionFactor',
  energyContent: 'energyContent',
});

export const MATERIAL_SORT_FIELDS = Object.freeze({});

export const MATERIAL_SEARCH_IN = Object.freeze(['name', 'material_id']);

export const MATERIAL_TYPES = Object.freeze({
  conventional: 'CONVENTIONAL',
  certified: 'CERTIFIED',
});

export const MATERIAL_FIELDS = Object.freeze({
  materialName: 'materialName',
  materialId: 'materialId',
  referenceId: 'referenceId',
  materialType: 'materialType',
  certificateType: 'certificateType',
  declarationUnit: 'declarationUnit',
  workingUnit: 'workingUnit',
  conversionFactor: 'conversionFactor',
  energyContent: 'energyContent',
});

export const EMPTY_MATERIAL_FORM = Object.freeze(
  Object.fromEntries(Object.values(MATERIAL_FIELDS).map((field) => [field, ''])),
);

const WEIGHT_UNIT_OPTIONS = Object.freeze([
  { value: 'MT', labelKey: 'UNIT_MT' },
  { value: 'kg', labelKey: 'UNIT_KG' },
  { value: 'lbs', labelKey: 'UNIT_LBS' },
]);

const VOLUME_UNIT_OPTIONS = Object.freeze([
  { value: 'CUBIC_METER', labelKey: 'UNIT_CUBIC_METER' },
  { value: 'CUBIC_METER_15C', labelKey: 'UNIT_CUBIC_METER_15C' },
  { value: 'gal', labelKey: 'UNIT_GALLON' },
]);

export const DISCRETE_WORKING_UNITS = Object.freeze(['Pair', 'Unit', 'Piece']);

export const NO_WORKING_UNIT = '';

const toOptions = (t, units) => units.map(({ value, labelKey }) => ({ value, label: t(labelKey) }));

export const buildDeclarationUnitOptions = (t) => [
  { value: 'group-weight', label: t('UNIT_GROUP_WEIGHT'), disabled: true },
  ...toOptions(t, WEIGHT_UNIT_OPTIONS),
  { value: 'group-volume', label: t('UNIT_GROUP_VOLUME'), disabled: true },
  ...toOptions(t, VOLUME_UNIT_OPTIONS),
];

export const buildWorkingUnitOptions = (t, declarationUnit) =>
  [
    { value: NO_WORKING_UNIT, label: t('COMMON_NONE') },
    ...toOptions(t, WEIGHT_UNIT_OPTIONS),
    ...toOptions(t, VOLUME_UNIT_OPTIONS),
    ...DISCRETE_WORKING_UNITS.map((unit) => ({ value: unit, label: unit })),
  ].filter((option) => option.value !== declarationUnit);
